import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=15f27072&scoped=true"
import script from "./user-detail.vue?vue&type=script&lang=js"
export * from "./user-detail.vue?vue&type=script&lang=js"
import style0 from "./user-detail.vue?vue&type=style&index=0&id=15f27072&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f27072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f27072')) {
      api.createRecord('15f27072', component.options)
    } else {
      api.reload('15f27072', component.options)
    }
    module.hot.accept("./user-detail.vue?vue&type=template&id=15f27072&scoped=true", function () {
      api.rerender('15f27072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/user/components/user-detail.vue"
export default component.exports